import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'; // Eklendi
import './index.css';
import App from './App'; // Ensure this is a default import
import reportWebVitals from './reportWebVitals';
import Cookies from 'js-cookie'; // Add this import

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter> {/* Eklendi */}
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();

